import { fireQuickWarningToast } from '../../../webmodule-common/other/toast-away';
import { getSupplier } from '../../dealer-franchisee/quotes/supplier-selector';
import { isSupplierUsable } from './supplier-guard-predicate';
import { LangFabricationPurchaseOrder } from '../../../localization/scripts/fabrication-purchase-orders/views/fabrication-purchase-order-lang';
import { QuoteSupplier } from '../../quotes/quote-service';

export async function getOnlineSupplierOrWarn(): Promise<QuoteSupplier | null> {
  const supplier = await getSupplier();
  if (!isSupplierUsable(supplier)) {
    fireQuickWarningToast(LangFabricationPurchaseOrder.supplierUnavailable());
    return null;
  }
  return supplier;
}
